import styled from 'styled-components';

export const Board = styled.div`
  flex: 1;
  display: flex;
  margin: 0 -10px;
  overflow-y: hidden;
  overflow-x: auto;
  .column {
    display: flex;
    flex-direction: column;
    margin: 0 10px;
    flex: 1;
    border-radius: 4px 4px 0 0;
    min-width: 188px;
    /* overflow: hidden; */
  }
  .sub-column-container {
    /* overflow: hidden; */
  }
  .sub-column {
    /* flex: 50%; */
    height: 50%;
    display: flex;
    flex-direction: column;
    margin: 10px 0;
    /* overflow: hidden; */
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
      border-radius: 4px 4px 0 0;
    }
  }
  .card-title {
    padding: 12px 16px;
    border-bottom: solid 1px #ddd;
  }
  .card-container {
    flex: 1;
    /* height: 50%; */
    /* display: flex; */
    flex-direction: column;
    padding: 10px;
    background: ${props => props.theme.palette.primary.light};
    overflow-y: auto;
  }
  .task-card {
    margin-bottom: 16px;
    min-height: min-content;
    .info {
      display: flex;
      border-top: solid 1px #e4e4e4;
      padding: 12px 16px;
      align-items: center;
      .assigned {
        flex: 1;
        display: flex;
        align-items: center;
        .icon-wrapper {
          display: flex;
          margin-right: 10px;
          height: 30px;
          width: 30px;
          border-radius: 15px;
          align-items: center;
          justify-content: center;
          background: #eee;
          overflow: hidden;
        }
      }
      .due-date {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
  .task-card-with-subtask {
    overflow-y: auto;
    background-color: #e6e6e6;
    margin-bottom: 10px;
    padding: 10px 10px 0px 10px;
    .title {
      margin-bottom: 10px;
    }
  }
`;
